import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import numeral from 'numeral';
import NP from 'number-precision';

const GeneralCargoFields = ({
  params,
  errors,
  onChange,
  calculator,
  tax,
  valuation,
}) => {
  const { actualWeight, dimension } = params;
  const useActualWeight = NP.strip(actualWeight) > NP.strip(dimension);
  return (
    <div>
      <Row>
        <Col xs={3}>
          <Form.Group>
            <Form.Label>Actual Weight</Form.Label>
            <Form.Control
              type="number"
              name="actualWeight"
              value={params.actualWeight}
              onChange={onChange}
              placeholder="Enter Weight in KG"
              isInvalid={errors.actualWeight}
              isValid={useActualWeight}
            />
          </Form.Group>
        </Col>
        <Col xs={2}>
          <Form.Group>
            <Form.Label>Length</Form.Label>
            <Form.Control
              type="number"
              name="dimensionLength"
              value={params.dimensionLength}
              onChange={onChange}
              placeholder="Length"
              isInvalid={errors.dimensionLength}
            />
          </Form.Group>
        </Col>
        <Col xs={2}>
          <Form.Group>
            <Form.Label>Width</Form.Label>
            <Form.Control
              type="number"
              name="dimensionWidth"
              value={params.dimensionWidth}
              onChange={onChange}
              placeholder="Width"
              isInvalid={errors.dimensionWidth}
            />
          </Form.Group>
        </Col>
        <Col xs={2}>
          <Form.Group>
            <Form.Label>Height</Form.Label>
            <Form.Control
              type="number"
              name="dimensionHeight"
              value={params.dimensionHeight}
              onChange={onChange}
              placeholder="Height"
              isInvalid={errors.dimensionHeight}
            />
          </Form.Group>
        </Col>
        <Col xs={3}>
          <Form.Group>
            <Form.Label>Dimension</Form.Label>
            <Form.Control
              name="dimension"
              value={numeral(params.dimension).format('0,0.00')}
              disabled
              isValid={!useActualWeight}
            />
          </Form.Group>
        </Col>
      </Row>
      <hr />
      <Row>
        <Col>
          <Form.Group>
            <Form.Label>Declared Value</Form.Label>
            <Form.Control
              type="number"
              name="declaredValue"
              value={params.declaredValue}
              onChange={onChange}
              placeholder="Enter Value"
              isInvalid={errors.declaredValue}
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group>
            <Form.Label>Valuation {calculator.valuationPercent} %</Form.Label>
            <Form.Control
              name="valuation"
              type="number"
              value={valuation}
              disabled
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group>
            <Form.Label>Tax {calculator.taxPercent} %</Form.Label>
            <Form.Control name="tax" type="number" value={tax} disabled />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group>
            <Form.Label>Freight Charge</Form.Label>
            <Form.Control
              name="freighCharge"
              value={
                params.freightCharge
                  ? numeral(params.freightCharge).format('0,0.00')
                  : numeral(0).format('0,0.00')
              }
              disabled
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export default GeneralCargoFields;
